<template>
  <div class="card">
    
    <div class="card-body">
        <h5 class="card-title">Search Syspro for {{SearchType}}</h5>
        <div class="card-text">
           <form class="p-lg-5">
              
            <label for="StockCodeSearch" class="form-label">Stock Code</label>
                <div class="input-group mb-3">                    
                    <input type="text" ref="StockCodeInput" class="form-control" id="StockCodeSearch" v-model="StockCodeInput" placeholder="Search stock code or part Description"/> 
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="checkSendServer"><i class="bi bi-search"></i></button>
                </div>
              <span v-show='loading'>
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Loading...
            </span>
            <div class="overflow-auto" style="max-height: 25vh;">
              <listStockCodesVue v-show='!loading'  :StockList="StockListSearch" @Select="selectStockCode"></listStockCodesVue>

            </div>
            <div v-if="!loading && noRows">
              <div class="alert alert-warning d-flex align-items-center" role="alert">
              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Warning:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                  <div>
                      No Rows found
                  </div>
              </div>
            </div>
            <div class="pb-1 small">
                <label for="Route" class="form-label form-label-sm">Route</label>
                <input type="text" class="form-control form-control-sm" id="Route" v-model="route" placeholder="Syspro Route">
              </div>
            </form>
            
        </div>
        <!-- <button class="btn btn-primary" >Next</button> -->
    </div>
    </div>
</template>

<script>
import {BaseDataService} from '../../services/BaseData.service';
import listStockCodesVue from './listStockCodes.vue';
export default {
    emits: ["Select"],
    props: { StockCode: String,PartCategory: String},
    components: {
    listStockCodesVue
  },
    data: () => ({
    loading:true,
    StockCodeInput:"",
    StockListSearch:[],
    PartCategoryUsed:"M",
    noRows:false,
    route:"0"
  }),
  computed:{
    SearchType(){
      return this.PartCategoryUsed=="M"?"Made In Parts":"Bought out Parts"
    }
  },
  watch:{
    StockCodeInput(){
      this.checkSendServer();
    }
  },
  mounted(){
    this.loading = false;
    if(this.StockCode){
        if(this.StockCode!=''){
            this.StockCodeInput=this.StockCode;
        }
    }
    this.PartCategoryUsed = "M";
    if(this.PartCategory){
      this.PartCategoryUsed = this.PartCategory;
    }
    this.$refs.StockCodeInput.focus();
  },
  methods: { 
    checkSendServer(){
        if(this.TimerTik){
            window.clearTimeout(this.TimerTik);
        } 
        this.TimerTik =  window.setTimeout(this.sendSearch.bind(this),600);
    },
    sendSearch(){
      window.clearTimeout(this.TimerTik);
      if(this.StockCodeInput.length>3){
        this.loading = true;
        this.noRows = false
        BaseDataService.searchPartCat(this.StockCodeInput,this.PartCategoryUsed).then(x=>{
            this.StockListSearch = x.data;
            this.loading = false;
            window.clearTimeout(this.TimerTik);
            if(this.StockListSearch.length==0){
              this.noRows = true
            }
        });
      }
    },
    selectStockCode(row) {
        row.route = this.route;
        this.$emit("Select", row);
        
    }
  }
}
</script>

<style>

</style>